export default "__VITE_ASSET__BmApCXAa__"